import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonTranslationModule, CommonUIModule, MasterDetailModule } from '@sdbn/common';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { RFIDCardComponent } from './component/rfid-card.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonUIModule,
    CommonTranslationModule,
    ApplicationClientCommonModule,
    MasterDetailModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatTableModule,
    MatInputModule,
    MatCheckboxModule
  ],
  declarations: [
    RFIDCardComponent
  ]
})
export class RFIDCardModule { }

